import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { loadModulePerformanceAsync, loadTestPerformanceAsync, loadQuestionPerformanceAsync } from '../dashboardSlice';
import { ModulePerformanceChart } from '../components/ModulePerformanceChart';
import { TestPerformanceChart } from '../components/TestPerformanceChart';
import { QuestionPerformanceChart } from '../components/QuestionPerformanceChart';

// Cada aba só busca seus dados na primeira vez que é selecionada — mesmo
// padrão do HeatmapPerformancePage.js (era 3 páginas/rotas separadas antes:
// /desempenho/modulos, /desempenho/provas, /desempenho/questoes).
const TAB_LOADERS = [
    (dispatch) => dispatch(loadModulePerformanceAsync({ activeOnly: true })),
    (dispatch) => dispatch(loadTestPerformanceAsync({ activeOnly: true })),
    (dispatch) => dispatch(loadQuestionPerformanceAsync({ moduleId: null, testId: null, limit: 100, activeOnly: true })),
];

const PerformancePage = () => {
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(0);
    const loadedTabs = useRef(new Set());

    const loadTab = useCallback((index) => {
        loadedTabs.current.add(index);
        TAB_LOADERS[index]?.(dispatch);
    }, [dispatch]);

    useEffect(() => {
        loadTab(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Recarrega só a aba ativa (ignora o cache de "já carreguei antes").
    const onRefresh = () => loadTab(activeIndex);

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <div className="flex justify-content-between align-items-center mb-3">
                        <h5 className="m-0">Desempenho geral</h5>
                        <Button
                            icon="pi pi-refresh"
                            rounded
                            text
                            onClick={onRefresh}
                        />
                    </div>
                    <TabView
                        activeIndex={activeIndex}
                        onTabChange={(e) => {
                            setActiveIndex(e.index);
                            if (!loadedTabs.current.has(e.index)) loadTab(e.index);
                        }}
                    >
                        <TabPanel header="Módulo">
                            <ModulePerformanceChart />
                        </TabPanel>
                        <TabPanel header="Prova">
                            <TestPerformanceChart />
                        </TabPanel>
                        <TabPanel header="Questão">
                            <QuestionPerformanceChart />
                        </TabPanel>
                    </TabView>
                </div>
            </div>
        </div>
    );
};

export default PerformancePage;
